var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tmallBox', { inApp: _vm.$root.$data.isApp }]},[_c('common-title',{attrs:{"titleName":"激活中心","bcColor":'none',"zIndex":1000}}),_c('MemberActive')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }